/* eslint-disable */
import React, { useEffect, useReducer, useState } from 'react';
import PropTypes  from 'prop-types';
import Table, { TableHead, TableBody } from '../Table';
import Paginator from '../Paginator';
import Group from '../Group';
import Search from '../Search';
import Vspace from '../Vspace';
import { Dropdown } from '../Dropdown';
import Button from '../Button';
import Switch from '../Switch';
import { Col, Row } from '../FlexBoxGrid';
import Checkbox from '../Checkbox';
import { Paragraph, Text } from '../Typography';
import Box from '../Box';
import DropdownExport from '../DropdownExport';

export const ACTIONS = {
    GENERIC_SEARCH: 'generic_search',
    TOGGLE_COLUMNS_DROPDOWN: 'toggle_columns_dropdown',
    TOGGLE_CHECK_COLUMN: 'toggle_check_column',
    CHECK_ALL_COLUMNS: 'check_all_columns',
    UNCHECK_ALL_COLUMNS: 'uncheck_all_columns',
    SET_CLASSNAME_HIDDEN_COLUMNS: 'set_classname_hidden_columns',
    TOGGLE_CHECK_STATUS: 'toggle_check_status',
    UPDATE_FILTERED_LIST: 'update_filtered_list'
}

const defaultI18n = { 
    NOTHING_FOUND: 'Nada encontrado',
    SET_UP_COLUMNS: 'Configurar colunas',
    SELECT: 'Selecionar',
    ALL: 'Todas',
    NONE: 'Nenhuma',
    STATUS: 'Status',
    EXPORT: 'Exportar',
    SEARCH: 'Buscar'
};

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.GENERIC_SEARCH:
            let stringToFind = typeof action.payload.stringToFind === 'string' ? action.payload.stringToFind.toLowerCase() : state.searchValue;
            let newFilteredData = action.payload.data.filter(obj => {
                return JSON.stringify(obj).toLowerCase().includes(stringToFind) && 
                    (Array.isArray(state.statusCheckedList) ? state.statusCheckedList.indexOf(obj.status) > -1 : true);
            });
            return { ...state, filteredData: newFilteredData, searchValue: stringToFind }
        
        case ACTIONS.TOGGLE_COLUMNS_DROPDOWN:
            return { ...state, columnDropdownIsOpen: !state.columnDropdownIsOpen }

        case ACTIONS.TOGGLE_CHECK_COLUMN:
            const { id, checked, localStorageColumnsConfigId } = action.payload;
            let columnsCheckedList = [ ...state.columnsCheckedList, id ];
            if (!checked) columnsCheckedList = columnsCheckedList.filter(item => item !== id);
            let isCheckAllColumns = state.columns.length === columnsCheckedList.length;
            let isCheckNoneColumns = columnsCheckedList.length === 0;
            localStorage.setItem(localStorageColumnsConfigId, JSON.stringify(columnsCheckedList));
            return { ...state, columnsCheckedList: columnsCheckedList, isCheckAllColumns: isCheckAllColumns, isCheckNoneColumns: isCheckNoneColumns }

        case ACTIONS.CHECK_ALL_COLUMNS:
            return { ...state, columnsCheckedList: state.columns.map(item => item), isCheckNoneColumns: false, isCheckAllColumns: true }

        case ACTIONS.UNCHECK_ALL_COLUMNS:
            return { ...state, columnsCheckedList: [], isCheckNoneColumns: true, isCheckAllColumns: false }

        case ACTIONS.SET_CLASSNAME_HIDDEN_COLUMNS:
            let hiddenColumnsClassName = '';
            if (Array.isArray(state.columns) && Array.isArray(state.columnsCheckedList)) {
                state.columns.map((column, index) => {
                    if (state.columnsCheckedList.indexOf(column) === -1) hiddenColumnsClassName += ` h-${index + 1}`;
                })
            }
            return { ...state, hiddenColumnsClassName: hiddenColumnsClassName };

        case ACTIONS.TOGGLE_CHECK_STATUS:
            const { status, checkedStatus } = action.payload;
            let statusCheckedList = [...state.statusCheckedList, status];
            if (!checkedStatus) statusCheckedList = state.statusCheckedList.filter(item => item !== status);
            return { ...state, statusCheckedList: statusCheckedList }

        case ACTIONS.UPDATE_FILTERED_LIST:
            return { ...state, filteredData: action.payload.data }

        default:
            return state;
    }
}

function DataTable(props) {
    const {
        id, 
        columns, 
        data, 
        pageSize, 
        statusList, 
        advancedFilter, 
        triggerAdvancedFilter, 
        loading, 
        isColumnsConfigurable, 
        filename,
        className,
        noExport
    } = props;

    const i18n = { ...defaultI18n, ...props.i18n };
    
    const localStorageColumnsConfigId = `config_cols_${id}`;
    const defaultColumns = isColumnsConfigurable ? ['', ...columns] : columns;
    const defaultColumnsCheckedList = isColumnsConfigurable ? (JSON.parse(localStorage.getItem(localStorageColumnsConfigId)) || ['', ...columns]) : columns;
    
    const defaultStateValues = { 
        filteredData: data, 
        columnDropdownIsOpen: false,
        columns: defaultColumns,
        columnsCheckedList: defaultColumnsCheckedList,
        isCheckAllColumns: defaultColumnsCheckedList.length === defaultColumns.length,
        isCheckNoneColumns: defaultColumnsCheckedList.length === 0,
        hiddenColumnsClassName: '',
        statusCheckedList: Object.keys(statusList),
        searchValue: ''
    };
    const [state, dispatch] = useReducer(reducer, defaultStateValues);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        dispatch({ type: ACTIONS.SET_CLASSNAME_HIDDEN_COLUMNS });
        dispatch({ type: ACTIONS.UPDATE_FILTERED_LIST, payload: { data: data } })
    }, [state.columnsCheckedList, data])

    const handleSearch = (e) => {
        dispatch({ type: ACTIONS.GENERIC_SEARCH, payload: { stringToFind: (e ? e.target.value : null), data: data } })
    }

    const handleColumnsDropdown = () => {
        dispatch({ type: ACTIONS.TOGGLE_COLUMNS_DROPDOWN });
    }

    const handleClickCheckbox = (e) => {
        dispatch({ type: ACTIONS.TOGGLE_CHECK_COLUMN, payload: { checked: e.target.checked, id: e.target.id, localStorageColumnsConfigId: localStorageColumnsConfigId } })
    }

    const handleClickCheckAll = (e) => {
        dispatch({ type: ACTIONS.CHECK_ALL_COLUMNS })
    }

    const handleClickUncheckAll = (e) => {
        dispatch({ type: ACTIONS.UNCHECK_ALL_COLUMNS })
    }

    const handleClickStatus = (e) => {
        dispatch({ type: ACTIONS.TOGGLE_CHECK_STATUS, payload: { status: e.target.id, checkedStatus: e.target.checked, data: data } })
        handleSearch();
    }

    const DropdownColumnsDesktop = () => {
        return (
            <Dropdown
                className={`mla hom ${ state.columnDropdownIsOpen ? 'active' : '' }`}
                trigger={
                    <Button className='inline' onClick={handleColumnsDropdown}>
                        {i18n.SET_UP_COLUMNS}
                    </Button>
                }>
                <Button className="button-close" onClick={handleColumnsDropdown} />
                <Text className='s11'>{i18n.SELECT}</Text>
                <Vspace className='sm' />
                <Group className='g5'>
                    <Switch
                        label={i18n.ALL}
                        type='radio'
                        onClick={handleClickCheckAll}
                        isChecked={state.isCheckAllColumns}
                    />
                    <Switch
                        label={i18n.NONE}
                        type='radio'
                        onClick={handleClickUncheckAll}
                        isChecked={state.isCheckNoneColumns}
                    />
                </Group>
                <hr className='sm' />
                <Row>
                    {
                        Array.isArray(columns) ?
                        columns.map((column, index) => {
                            return (
                                <Col className='col-xs-6'>
                                    <Checkbox
                                        id={column}
                                        key={`${column}_${index}`}
                                        type='circle'
                                        label={column}
                                        onClick={handleClickCheckbox}
                                        isChecked={state.columnsCheckedList.includes(column)}
                                    />
                                </Col>
                            )
                        }) : ''
                    }
                </Row>
            </Dropdown>
        )
    }

    const DropdownColumnsMobile = () => {
        return (
            <div className={`wac-featured-popover white hod ${ state.columnDropdownIsOpen ? 'active' : '' }`}>
                <button onClick={handleColumnsDropdown} className="wac-featured-popover-trigger"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="#FFFFFF"><path d="M64,39A25,25,0,1,0,89,64,25,25,0,0,0,64,39Zm0,44A19,19,0,1,1,83,64,19,19,0,0,1,64,83Z"/><path d="M121,48h-8.93a1,1,0,0,1-.94-.68,49.9,49.9,0,0,0-2-4.85,1,1,0,0,1,.18-1.15L115.62,35a7,7,0,0,0,0-9.9L102.89,12.38a7,7,0,0,0-9.9,0l-6.31,6.31a1,1,0,0,1-1.15.18,49.76,49.76,0,0,0-4.85-2,1,1,0,0,1-.68-.94V7a7,7,0,0,0-7-7H55a7,7,0,0,0-7,7v8.93a1,1,0,0,1-.68.94,49.9,49.9,0,0,0-4.85,2,1,1,0,0,1-1.15-.18L35,12.38a7,7,0,0,0-9.9,0L12.38,25.11a7,7,0,0,0,0,9.9l6.31,6.31a1,1,0,0,1,.18,1.15,49.76,49.76,0,0,0-2,4.85,1,1,0,0,1-.94.68H7a7,7,0,0,0-7,7V73a7,7,0,0,0,7,7h8.93a1,1,0,0,1,.94.68,49.9,49.9,0,0,0,2,4.85,1,1,0,0,1-.18,1.15L12.38,93a7,7,0,0,0,0,9.9l12.73,12.73a7,7,0,0,0,9.9,0l6.31-6.31a1,1,0,0,1,1.15-.18,49.76,49.76,0,0,0,4.85,2,1,1,0,0,1,.68.94V121a7,7,0,0,0,7,7H73a7,7,0,0,0,7-7v-8.93a1,1,0,0,1,.68-.94,49.9,49.9,0,0,0,4.85-2,1,1,0,0,1,1.15.18L93,115.62a7,7,0,0,0,9.9,0l12.73-12.73a7,7,0,0,0,0-9.9l-6.31-6.31a1,1,0,0,1-.18-1.15,49.76,49.76,0,0,0,2-4.85,1,1,0,0,1,.94-.68H121a7,7,0,0,0,7-7V55A7,7,0,0,0,121,48Zm1,25a1,1,0,0,1-1,1h-8.93a7,7,0,0,0-6.6,4.69,43.9,43.9,0,0,1-1.76,4.26,7,7,0,0,0,1.35,8l6.31,6.31a1,1,0,0,1,0,1.41L98.65,111.38a1,1,0,0,1-1.41,0l-6.31-6.31a7,7,0,0,0-8-1.35,43.88,43.88,0,0,1-4.27,1.76,7,7,0,0,0-4.68,6.6V121a1,1,0,0,1-1,1H55a1,1,0,0,1-1-1v-8.93a7,7,0,0,0-4.69-6.6,43.9,43.9,0,0,1-4.26-1.76,7,7,0,0,0-8,1.35l-6.31,6.31a1,1,0,0,1-1.41,0L16.62,98.65a1,1,0,0,1,0-1.41l6.31-6.31a7,7,0,0,0,1.35-8,43.88,43.88,0,0,1-1.76-4.27A7,7,0,0,0,15.93,74H7a1,1,0,0,1-1-1V55a1,1,0,0,1,1-1h8.93a7,7,0,0,0,6.6-4.69,43.9,43.9,0,0,1,1.76-4.26,7,7,0,0,0-1.35-8l-6.31-6.31a1,1,0,0,1,0-1.41L29.35,16.62a1,1,0,0,1,1.41,0l6.31,6.31a7,7,0,0,0,8,1.35,43.88,43.88,0,0,1,4.27-1.76A7,7,0,0,0,54,15.93V7a1,1,0,0,1,1-1H73a1,1,0,0,1,1,1v8.93a7,7,0,0,0,4.69,6.6,43.9,43.9,0,0,1,4.26,1.76,7,7,0,0,0,8-1.35l6.31-6.31a1,1,0,0,1,1.41,0l12.73,12.73a1,1,0,0,1,0,1.41l-6.31,6.31a7,7,0,0,0-1.35,8,43.88,43.88,0,0,1,1.76,4.27,7,7,0,0,0,6.6,4.68H121a1,1,0,0,1,1,1Z"/></svg></button>
                <div className="wac-featured-popover-content">
                    <Button onClick={handleColumnsDropdown} className="wac-featured-drawer-trigger" />
                    <Text className='s11'>{i18n.SELECT}</Text>
                    <Vspace className='sm' />
                    <Group className='g5'>
                        <Switch
                            label={i18n.ALL}
                            type='radio'
                            onClick={handleClickCheckAll}
                            isChecked={state.isCheckAllColumns}
                        />
                        <Switch
                            label={i18n.NONE}
                            type='radio'
                            onClick={handleClickUncheckAll}
                            isChecked={state.isCheckNoneColumns}
                        />
                    </Group>
                    <hr className='sm' />
                    <Row>
                    {
                        Array.isArray(columns) ?
                        columns.map((column, index) => {
                            return (
                                <Col className='col-xs-6'>
                                    <Checkbox
                                        id={column}
                                        key={`${column}_${index}`}
                                        type='circle' 
                                        label={column}
                                        onClick={handleClickCheckbox}
                                        isChecked={state.columnsCheckedList.includes(column)}
                                    />
                                </Col>
                            )
                        }) : ''
                    }
                    </Row>
                </div>
            </div>
        )
    }

    const StatusContainer = () => {
        return Object.keys(statusList).length ? (
            <>
                <Group className="vc g2 mv">
                    <Paragraph className="uppercase fw700">
                        {i18n.STATUS}
                    </Paragraph>
                    <Group className="g3 m-spread">
                        {
                            Object.keys(statusList).map((status) => {
                                let label = statusList[status];
                                return (
                                    <Switch
                                        id={status}
                                        key={status}
                                        className="mv"
                                        label={label}
                                        status={status}
                                        onClick={handleClickStatus}
                                        isChecked={state.statusCheckedList.includes(status)}
                                        type="checkbox"
                                    />
                                )
                            })
                        }
                    </Group>
                </Group>
                <Vspace className="lg hom" />
            </>
        ) : ''
    }

    const columnsWithDropdown = [DropdownColumnsMobile(), ...columns];
    return (
        <div id={id}>
            <Box className="mobile-box">
                {noExport ? null : (
                    <DropdownExport
                        i18n={i18n}
                        filename={filename}
                        data={state.filteredData}
                        columns={state.columnsCheckedList}
                    />
                )}
                { StatusContainer() }
                <Group className="vc g5 mv no-print">
                    <Search
                        id={`search_field_${id}`}
                        onKeyUp={handleSearch}
                        placeholder={i18n.SEARCH}
                    />
                    { triggerAdvancedFilter }
                    { isColumnsConfigurable ? DropdownColumnsDesktop() : '' }
                </Group>
                <Vspace />
                { advancedFilter || '' }
            </Box>
            <Vspace />
            <div className={`fixed-cols-table f-1 ${className || ''} ${state.hiddenColumnsClassName} ${loading ? 'loading' : ''}`}>
                <div className="fixed-cols no-print">
                    <Table>
                        <TableHead 
                            columns={isColumnsConfigurable ? columnsWithDropdown : state.columns} 
                        />
                        <TableBody 
                            columns={state.columns} 
                            data={state.filteredData}
                            statusList={statusList}
                            offset={offset}
                            pageSize={pageSize}
                            i18n={i18n}
                        />
                    </Table>
                </div>
                <div className="scroll-cols">
                    <Table>
                        <TableHead 
                            columns={isColumnsConfigurable ? columnsWithDropdown : state.columns} 
                        />
                        <TableBody 
                            columns={state.columns} 
                            data={state.filteredData}
                            statusList={statusList}
                            offset={offset}
                            pageSize={pageSize}
                            i18n={i18n}
                        />
                    </Table>
                    <Paginator
                        paginatorSize={state.filteredData.length}
                        pageSize={pageSize}
                        onOffsetChange={setOffset}
                        setRowsLabel={({ from, to, count }) => `${from}-${to} of ${count}`}
                    />
                </div>
            </div>
        </div>
    )
}

DataTable.defaultProps = {
    id: '',
    columns: [],
    data: [],
    pageSize: 15,
    statusList: {},
    advancedFilter: <></>,
    triggerAdvancedFilter: <></>,
    loading: false,
    isColumnsConfigurable: true,
    i18n: defaultI18n,
    filename: 'generated',
    className: '',
    noExport: false
}

DataTable.propTypes = {
    id: PropTypes.string.isRequired,
    columns: PropTypes.object.isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    pageSize: PropTypes.number,
    statusList: PropTypes.object,
    advancedFilter: PropTypes.object,
    triggerAdvancedFilter: PropTypes.object,
    loading: PropTypes.bool,
    isColumnsConfigurable: PropTypes.bool,
    i18n: PropTypes.object,
    filename: PropTypes.string,
    className: PropTypes.string,
    noExport: PropTypes.bool,
}

export default DataTable;